import React from 'react';

import StartCard from './StartCard';
import AccountCard from './AccountCard';
import SendCard from './SendCard';
import CloseCard from './CloseCard';

const cards = {
  start: <StartCard name='start' />,
  account: <AccountCard name='account' />,
  send: <SendCard name='send' />,
  close: <CloseCard name='close' />
}

const list = ['start','account','send','close'];
const wizard = {cards,list};

export {cards,list};

export default wizard;
